import React, { useState, useEffect } from 'react';
import { makeStyles, Button } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import { machineParameterNames as params } from '../../Config/constants'
import GreenButton from '../Shared/GreenButton';
import MultipleValueParameter from './MultipleValueParameter';
import Parameter from './Parameter'
import { dataService } from '../../Services/data.service'
import { toast } from 'react-toastify';
import { connect } from 'react-redux';

export const MachineParametersDrawer = (props) => {
    const classes = useStyles();

    const [machineParameters, setMachineParameters] = useState([])
    const [machineSettingId, setMachineSettingId] = useState(null)

    useEffect(() => {
        let mounted = true

        dataService.getMachineSettingsByMachineId(props.workstation.selectedWorkstation).then(setting => {
            if (mounted) {
                setMachineParameters(JSON.parse(setting.setting))
                setMachineSettingId(setting.id)
            }
        }).catch((error) => { toast.error(error, { position: "top-center" }) })

        return function cleanup() {
            mounted = false
        }
    }, [props.workstation.selectedWorkstation]);

    function saveSettings() {
        //Speed and rpmPump saving
        let tempMachineParameters = machineParameters.slice()
        if (Array.isArray(props.machineParameter.speed) && Array.isArray(props.machineParameter.rpmPump)) {
            if (props.machineParameter.speed.some(x => x.lineNumber === parseInt(props.productionOrder.machineCode))) {
                tempMachineParameters.find(p => p.name === params.treksnelheid).values[0].value = String(props.machineParameter.speed.find(x => x.lineNumber === parseInt(props.productionOrder.machineCode)).speed)
                tempMachineParameters.find(p => p.name === params.pomptoerental).values[0].value = String(props.machineParameter.rpmPump.find(x => x.lineNumber === parseInt(props.productionOrder.machineCode)).rpmPump)
            }
        }
        dataService.saveMachineSetting(props.workstation.selectedWorkstation, tempMachineParameters, machineSettingId).then().catch((error) => { toast.error(error, { position: "top-center" }) })
        dataService.getMachineSettingsByMachineId(props.workstation.selectedWorkstation).then(setting => {

            if (JSON.stringify(JSON.parse(setting.setting)) !== JSON.stringify(machineParameters)) {
                setMachineParameters(JSON.parse(setting.setting))
                setMachineSettingId(setting.id)
            }

        }).catch((error) => { toast.error(error, { position: "top-center" }) })
        props.openDrawer(false)
    }

    function parameterChanged(event, paramId, paramNumber) {
        let tempMachineParameters = machineParameters.slice()
        tempMachineParameters.find(x => x.id === paramId).values.find(y => y.number === paramNumber).value = event.target.value

        setMachineParameters(tempMachineParameters)
    }

    return (
        <Drawer variant="temporary" className={classes.drawer} anchor='right' open={props.drawerOpen} classes={{ paper: clsx({ [classes.drawerOpen]: props.drawerOpen, [classes.drawerClose]: !props.drawerOpen, }), }} onClose={() => props.openDrawer(false)} transitionDuration={500}>
            <div className={classes.drawerBody}>
                <div className={classes.header}>
                    <div className={classes.title}>Machine parameters</div>
                    <div className={classes.close}>
                        <Button className={classes.closeButton} onClick={() => props.openDrawer(false)}>
                            <CloseIcon className={classes.closeButtonIcon}></CloseIcon>
                        </Button>
                    </div>
                </div>
                {(machineParameters && machineParameters.length > 0) ? <div className={classes.body}>
                    <div className={classes.upperContainer}>
                        <div className={classes.upperLeftContainer}>
                            <MultipleValueParameter param={machineParameters.find(p => p.name === params.vacuümpomp)} parameterChanged={parameterChanged}></MultipleValueParameter>
                            <Parameter param={machineParameters.find(p => p.name === params.opening)} parameterChanged={parameterChanged}></Parameter>
                            <MultipleValueParameter param={machineParameters.find(p => p.name === params.temperatuur)} parameterChanged={parameterChanged}></MultipleValueParameter>
                            <MultipleValueParameter param={machineParameters.find(p => p.name === params.luchtblazer)} parameterChanged={parameterChanged}></MultipleValueParameter>
                            <MultipleValueParameter param={machineParameters.find(p => p.name === params.oventemperatuur)} parameterChanged={parameterChanged}></MultipleValueParameter>
                        </div>
                        <div className={classes.upperRightContainer}>
                            <Parameter param={machineParameters.find(p => p.name === params.coronaKw)} parameterChanged={parameterChanged}></Parameter>
                            <MultipleValueParameter param={machineParameters.find(p => p.name === params.trekrollendruk)} parameterChanged={parameterChanged}></MultipleValueParameter>
                            <Parameter param={machineParameters.find(p => p.name === params.output)} parameterChanged={parameterChanged}></Parameter>
                            <Parameter speed={Array.isArray(props.machineParameter.speed) ? props.machineParameter.speed.some(x => x.lineNumber === parseInt(props.productionOrder.machineCode)) && props.machineParameter.speed.find(x => x.lineNumber === parseInt(props.productionOrder.machineCode)).speed : 0} param={machineParameters.find(p => p.name === params.treksnelheid)} parameterChanged={parameterChanged}></Parameter>
                            <Parameter rpmPump={Array.isArray(props.machineParameter.rpmPump) ? props.machineParameter.rpmPump.some(x => x.lineNumber === parseInt(props.productionOrder.machineCode)) && props.machineParameter.rpmPump.find(x => x.lineNumber === parseInt(props.productionOrder.machineCode)).rpmPump : 0} param={machineParameters.find(p => p.name === params.pomptoerental)} parameterChanged={parameterChanged}></Parameter>
                        </div>
                    </div>
                    <div className={classes.lowerContainer}>
                        <MultipleValueParameter param={machineParameters.find(p => p.name === params.matrijstemperatuurzones)} parameterChanged={parameterChanged}></MultipleValueParameter>
                    </div>
                    <div className={classes.buttonContainer}>
                        <GreenButton text={"SAVE"} onClick={() => saveSettings()}></GreenButton>
                    </div>
                </div> : <React.Fragment></React.Fragment>}
            </div>
        </Drawer>)
}

const useStyles = makeStyles(() => ({
    drawerBody: {
        width: "100%",
        height: "100%",
        background: 'linear-gradient(#EFEFEF,#FFFFFF)',
        padding: "20px",
        paddingRight: "5px",
        paddingTop: "10px",
        boxSizing: "border-box"
    },
    closeButton: {
        float: 'right',
        "&:hover": {
            background: "#EFEFEF"
        },
        paddingRight: "0px !important",
        width: "25px !important",
        height: "25px !important",
        minWidth: "0px !important",
    },
    closeButtonIcon: {
        marginRight: "6px"
    },
    drawerOpen: {
        width: "646px",
    },
    drawerClose: {
        width: 0
    },
    close: {
        width: "20%",
        float: 'left',
    },
    title: {
        float: 'left',
        width: "80%",
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        marginTop: "10px"
    },
    header: {
        width: "100%",
        height: "5%",
        marginBottom: "20px"
    },
    body: {
        width: "100%",
        height: "95%"
    },
    upperLeftContainer: {
        float: "left",
        width: "50%",
        boxSizing: "border-box",
        borderRight: "1px solid #DEDEDE",
        height: "500px",
    },
    upperContainer: {
        height: "500px",
    },
    upperRightContainer: {
        float: "left",
        width: "50%",
        boxSizing: "border-box",
        height: "500px",
        paddingLeft: "20px"
    },
    lowerContainer: {
        borderTop: "1px solid #DEDEDE",
        width: "100%",
        paddingTop: "20px",
        height: "330px"
    },
    buttonContainer: {
        height: "50px",
        width: "646px",
        textAlign: "center",
        backgroundColor: "white",
        position: "fixed",
        bottom: "0",
        right: "0",
        boxShadow: "0px 3px 25px #00000029",
        paddingTop: "10px"
    }

}));


function mapStateToProps(state) {
    return { machineParameter: state.machineParameter }
}

export default connect(mapStateToProps)(MachineParametersDrawer)

